import { render, staticRenderFns } from "./CreateForm - 副本.vue?vue&type=template&id=da88863c"
import script from "./CreateForm - 副本.vue?vue&type=script&lang=js"
export * from "./CreateForm - 副本.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports